// removed by extract-text-webpack-plugin
module.exports = {"pdfpaper":"CentricUI__sideBar__PdfSidebar__pdfpaper","drawer":"CentricUI__sideBar__PdfSidebar__drawer","pdf":"CentricUI__sideBar__PdfSidebar__pdf","button":"CentricUI__sideBar__PdfSidebar__button","footer":"CentricUI__sideBar__PdfSidebar__footer","drawerContent":"CentricUI__sideBar__PdfSidebar__drawerContent","drawerFooter":"CentricUI__sideBar__PdfSidebar__drawerFooter"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/pdf/sideBar/PdfSidebar.css
// module id = 919
// module chunks = 10